import { Icon, Text } from '@cad-arc';
import classnames from 'classnames';
import { parseJSON } from 'date-fns';
import React from 'react';
import { TempAdditionalInfoViewWithPinFields, Priority } from '../../types';
import { formatAdditionalInfoTime } from './additional-info-row';
import { FlagRenderer } from '../../../common/components/flag-renderer/flag-renderer';
import { NarrativeActionMenu } from './narrative-action-menu';
import styles from './pinned-narrative-row.module.css';

export function PinnedNarrativeRow({
    data: info,
    isFirst,
    isLast,
    isExpanded,
    currentUserId,
    agencyEventNumberToIdMap,
    isScheduledEvent = false,
    isFirstResponder = false,
    onOpenEvent,
}: {
    data: TempAdditionalInfoViewWithPinFields;
    isFirst: boolean;
    isLast: boolean;
    isExpanded: boolean;
    currentUserId?: number;
    agencyEventNumberToIdMap?: Record<string, number>;
    isScheduledEvent?: boolean;
    isFirstResponder?: boolean;
    onOpenEvent?: (id: number) => void;
}): React.JSX.Element {
    const isUrgent = info.priority === Priority.HIGH;
    const isOnly = isFirst && isLast;

    return (
        <div
            className={classnames(styles['pinned-row'], {
                [styles['first']]: isFirst && !isOnly,
                [styles['last']]: isLast && !isOnly,
                [styles['only']]: isOnly,
                [styles['high-priority']]: isUrgent,
            })}
            data-testid="PINNED_NARRATIVE_ROW"
            data-infoid={info.id}
        >
            <Icon icon="Pin" className={styles['pin-icon']} data-testid="PINNED_NARRATIVE_ICON" />
            <Text
                as="div"
                className={classnames(
                    styles['text'],
                    isFirstResponder ? styles['text-lg'] : undefined,
                    { [styles['clamped']]: !isExpanded }
                )}
                data-testid="PINNED_NARRATIVE_TEXT"
            >
                <FlagRenderer
                    text={info.text}
                    agencyEventNumberToIdMap={agencyEventNumberToIdMap}
                    isFirstResponder={isFirstResponder}
                    onAgencyEventNumberClick={({ eventId }) => {
                        onOpenEvent?.(eventId);
                    }}
                />
            </Text>
            <div className={styles['meta']}>
                <Text
                    as="div"
                    className={classnames(styles['date'], isFirstResponder && styles['date-lg'])}
                >
                    {formatAdditionalInfoTime(parseJSON(info.createdDateUtc), new Date())}
                </Text>
                <Text
                    as="div"
                    className={classnames(
                        styles['author'],
                        isFirstResponder && styles['author-lg']
                    )}
                >
                    {info.authorCallSign || info.userInitials}
                </Text>
            </div>
            <NarrativeActionMenu
                info={info}
                currentUserId={currentUserId}
                isPinned={true}
                isScheduledEvent={isScheduledEvent}
                isFirstResponder={isFirstResponder}
            />
        </div>
    );
}
